import Phaser from 'phaser';

export default class Utils {
    private scene: Phaser.Scene;

    constructor(scene: Phaser.Scene) {
        this.scene = scene;
    }

    /**
     * Fixes rounding issues
     *
     * @param {Number} value
     * @param {Number} precision
     * @returns
     */
    fixRounding(value: number, precision: number = 2) {
        var power = Math.pow(10, precision || 0);
        return Math.round(value * power) / power;
    }

    /**
     * Waits for a given amount of time
     *
     * @param {Phaser.Scene} scene
     * @param {integer} delay msec
     */
    wait(delay: number): Promise<void> {
        return new Promise((resolve) => {
            this.activeScene.time.addEvent({
                delay,
                callback: () => resolve(),
            });
        });
    }

    get activeScene() {
        return this.scene.scene.manager.getScenes(true)[0];
    }
}
